import {ChangeDetectorRef, Component, ElementRef, HostListener, Inject, OnInit, AfterViewInit, TemplateRef, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {TreatmentEndoDataModel} from '../../models/treatment-endo-data.model';
import {EnumValidValueItemModel} from '../../../../models/enum/enum-valid-value-item.model';
import {TreatmentEndoEditColumnModel} from '../../models/treatment-endo-edit-column.model';
import {TreatmentEndoCanalDataModel} from '../../models/treatment-endo-canal-data.model';
import {TreatmentEndoCanalEnumService} from '../../treatment-endo-canal-enum.service';
import {TreatmentService} from '../../../../services/treatment.service';
import {TdoDropdownModel} from '../../../../tdo-controls/common/tdo-basic-dropdown/models/tdo-dropdown.model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { ARService } from 'src/app/modules/ar/ar.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { Subscription , fromEvent } from 'rxjs';
import { TemplatePortal } from '@angular/cdk/portal';
import { filter, take } from 'rxjs/operators';
import { EditEnumDialogComponent } from 'src/app/dialog/edit-enum-dialog/edit-enum-dialog.component';

@Component({
  standalone: false,
  selector: 'app-treatment-endo-edit-column-dialog',
  templateUrl: './treatment-endo-edit-column-dialog.component.html',
  styleUrls: ['./treatment-endo-edit-column-dialog.component.scss']
})
export class TreatmentEndoEditColumnDialogComponent implements OnInit, AfterViewInit {
  @ViewChild('enumOptionsMenu') enumOptionsMenu: TemplateRef<any>;
  isLoading = true;
  treatmentModel: TreatmentEndoDataModel;
  title: string;
  columnPropertyNames: string[];
  columnEnums: EnumValidValueItemModel[][] = [];
  isenumEndoXWorkLength = false;
  enumEndoXWorkLengthMeets = '00000117-1000-0000-0000-000000000001';
  TreatmentEwlAwlFilter: string = 'TreatmentEwlAwlFilter';
  isTreatmentEwlAwlFilter: boolean = false;
  userTriggered: boolean = false;  
  dropdownModels1: TdoDropdownModel[] = [];
  dropdownModelsLengthFiltered: TdoDropdownModel[] = [];
  dropdownModelsLengthOriginal : TdoDropdownModel[] = [];
  dropdownModels2: TdoDropdownModel[] = [];
  dropdownModels3: TdoDropdownModel[] = [];
  formWidth: string = '400px';

  validValueItems: EnumValidValueItemModel[];

  isContextOpen: boolean = false;
  private overlayRef: OverlayRef | null;
  private sub: Subscription;
  // @HostListener('contextmenu', ['$event'])
  // onContextMenu(event: MouseEvent, enumValue : EnumValidValueItemModel[]): void {
  //   console.log('onContextMenu enumValue', enumValue);
  //   console.log('onContextMenu event', event);
  //     this.onRightMouseClick(event, enumValue);
  // }

  constructor(@Inject(MAT_DIALOG_DATA) private data: TreatmentEndoEditColumnModel,
              private enumService: TreatmentEndoCanalEnumService,
              private treatmentService: TreatmentService,
              private dialogRef: MatDialogRef<TreatmentEndoEditColumnDialogComponent>,
              private overlay: Overlay,
              private viewContainerRef: ViewContainerRef,
              private el: ElementRef,
              private localStorageService: LocalStorageService,
              private arService: ARService,
              private snackBar: MatSnackBar,
              private dialog: MatDialog,
              private cdr: ChangeDetectorRef) {
    this.title = data.title;
    this.treatmentModel = data.model;
    this.columnPropertyNames = data.columnPropertyNames;
    this.columnEnums = data.columnEnums;
  }

  ngOnInit(): void {
    if(this.columnPropertyNames.length > 1)
      {
        this.formWidth = '800px';
      }
    this.isLoading = false;
    if (this.columnEnums[0][0].ValidValueItemId === this.enumEndoXWorkLengthMeets) {
      this.isenumEndoXWorkLength = true
    }

    this.isTreatmentEwlAwlFilter = localStorage.getItem("isTreatmentEwlAwlFilter") === "true";

    for (const enu of this.columnEnums[0]) {
      this.dropdownModelsLengthOriginal.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
        if (enu.ItemDisplayValue && !enu.ItemDisplayValue.endsWith('5') && this.isTreatmentEwlAwlFilter) {
        this.dropdownModelsLengthFiltered.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
        }
    }
    this.dropdownModels1 = this.dropdownModelsLengthOriginal ;

    if (this.columnPropertyNames.length > 1) {
      for (const enu of this.columnEnums[1]) {
        this.dropdownModels2.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
      }

      for (const enu of this.columnEnums[2]) {
        this.dropdownModels3.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
      }
    }

    if(this.isTreatmentEwlAwlFilter && this.isenumEndoXWorkLength)
    {
      this.dropdownModels1 = this.dropdownModelsLengthFiltered;
      this.columnEnums[0] = this.columnEnums[0].filter(p => !p.ItemDisplayValue.endsWith('5'));
    }
  }

  ngAfterViewInit(): void {
    // Allow initial rendering to complete, then scroll to selected items
    setTimeout(() => this.scrollSelectedItemsIntoView(), 0);
  }

  onFilterByLenght(event: MatCheckboxChange) {
      if (event.checked) {
          this.dropdownModels1 = this.dropdownModelsLengthFiltered;
          this.columnEnums[0] = this.columnEnums[0].filter(p => !p.ItemDisplayValue.endsWith('5'));
          this.saveFilterParamsToDB('true');
          localStorage.setItem('isTreatmentEwlAwlFilter', 'true');
      } else {
        this.dropdownModels1 = this.dropdownModelsLengthOriginal ;
        this.columnEnums[0] = this.dropdownModelsLengthOriginal .map(p => p.value);
        this.saveFilterParamsToDB('false');
        localStorage.setItem('isTreatmentEwlAwlFilter', 'false');
      }
    }

    saveFilterParamsToDB(isActive: string) {
      const userId = this.localStorageService.currentUserData.authdata.userid;
      this.arService.saveUserParams(isActive, userId, this.TreatmentEwlAwlFilter).subscribe(saved => {
        if (saved) {
          // save successful
          this.createMessage('Filter settings saved', 'Success');
        }
      }, err => {
        this.createMessage('Error saving filter settings', 'Error');
      });
    }

    createMessage(message, type) {
      this.snackBar.open(message, type, {
        duration: 3000,
        verticalPosition: 'top'
      });
    }

  onOkClick() {
    this.dialogRef.close({
      treatmentModel: this.treatmentModel,
      dropdownModels: {
        lengthOriginal: this.dropdownModelsLengthOriginal,
        models2: this.dropdownModels2,
        models3: this.dropdownModels3
      }
    });
  }

  onCancelClick() {
    this.dialogRef.close(null);
  }

  getDocumentFormToothNumber() {
    if (this.treatmentModel) {
      return this.treatmentModel.cfgTeeth[0].cfgToothDescriptions[0].Notation;
    } else {
      return null;
    }
  }

  getModelCanalType(model: TreatmentEndoCanalDataModel) {
    const enu = this.enumService.toothCanalEnums.find(p => p.ValidValueItemId === model.enumToothCanalID);
    if (enu) {
      return enu.ItemDisplayValue;
    } else {
      return null;
    }
  }

  // trackBy helpers to prevent unnecessary re-renders and preserve scroll positions
  trackByCanal(index: number, model: TreatmentEndoCanalDataModel): any {
    return model?.TreatmentCanalID ?? index;
  }

  trackByIndex(index: number): number {
    return index;
  }

  trackByEnum(index: number, item: EnumValidValueItemModel): any {
    return item?.ValidValueItemId ?? index;
  }

  onItemSelected(ValidValueItemId: string, model: TreatmentEndoCanalDataModel, propertyName: string) {
    // model.selectedEnumId = ValidValueItemId;
    // model[propertyName] = ValidValueItemId;
    // this.treatmentService.saveCanalItem(model).subscribe((res) => {
    //   model = res;
    // });
    this.userTriggered = true;
    if (model[propertyName] === ValidValueItemId) {
      // Deselect if the same item is clicked
      model[propertyName] = null;
      model.selectedEnumId = null;
    } else {
      // Select the new item
      model[propertyName] = ValidValueItemId;
      model.selectedEnumId = ValidValueItemId;
    }
    // Save the updated model
    this.userTriggered = false;
    this.cdr.detectChanges(); // Ensure Angular updates the view
    
    this.treatmentService.saveCanalItem(model).subscribe((res) => {
      Object.assign(model, res);
    });
  }

  // no-op retained for compatibility if needed in the future
  setUserTriggered(value: boolean) {
    this.userTriggered = value;
  }

  private scrollSelectedItemsIntoView(): void {
    if (!this.treatmentModel || !this.treatmentModel.dataTreatmentEndoCanals || !this.columnPropertyNames) {
      return;
    }

    try {
      for (let i = 0; i < this.columnPropertyNames.length; i++) {
        const propertyName = this.columnPropertyNames[i];
        for (const model of this.treatmentModel.dataTreatmentEndoCanals) {
          const selectedId = model[propertyName];
          if (!selectedId) {
            continue;
          }
          const domId = `selected-[${i}]${selectedId}-${model.TreatmentCanalID}`;
          const element = document.getElementById(domId) as HTMLElement | null;
          if (element) {
            element.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'nearest' });
          }
        }
      }
    } catch {
      // Safeguard: ignore scrolling errors silently
    }
  }

  onDropdownSelect(event: TdoDropdownModel, propertyName: string) {
    for (let model of this.treatmentModel.dataTreatmentEndoCanals) {
      model[propertyName] = event.value.ValidValueItemId;
      var items = this.el.nativeElement.querySelectorAll('.list-item');
      items.forEach((i) => { 
        if(i.innerText == event.label){
          i.scrollIntoView();
        }
      });

      // TODO: THIS SHOULD NOT BE DONE THIS WAY.  All should be saved at the same time.
      this.treatmentService.saveCanalItem(model).subscribe((res) => {
        model = res;
      });
    }
  }

  onRightMouseClick(event: MouseEvent, enumValue: any ) {
    console.log('onRightMouseClick enumValue', enumValue);
    console.log('onRightMouseClick event', event);
    console.log('onRightMouseClick enumValue[0].enumValidValue', enumValue[0]?.enumValidValue);
    console.log('onRightMouseClick enumValue[0].enumValidValue.isSystem', enumValue[0]?.enumValidValue?.isSystem);
    // if (enumValue === undefined || enumValue[0].enumValidValue.isSystem) {
    //    return;
    //  }
      if (enumValue === undefined ) {
       return;
     }
     event.preventDefault();
     this.validValueItems = enumValue;
     this.openContext(event, this.enumOptionsMenu, enumValue);
 }

 openContext({ x, y }: MouseEvent, template: TemplateRef<any>, data: any, closeOnItemClick = true): void {
  console.log('openContext data', data);
  console.log('openContext x', x);
  console.log('openContext y', y);
  console.log('openContext template', template);
  console.log('openContext closeOnItemClick', closeOnItemClick);
   this.isContextOpen = true;
   this.closeContext();
   x = x + 50;
   y = y - 20;
   const positionStrategy = this.overlay.position().flexibleConnectedTo({ x, y }).withPositions([
       {
           originX: 'end',
           originY: 'bottom',
           overlayX: 'end',
           overlayY: 'top'
       }
   ]);
 
   this.overlayRef = this.overlay.create({
       positionStrategy,
       scrollStrategy: this.overlay.scrollStrategies.close()
   });
 
   this.overlayRef.attach(new TemplatePortal(template, this.viewContainerRef, { $implicit: data }));
 
   this.sub = fromEvent<MouseEvent>(document, 'click')
       .pipe(
           filter(event => {
               if (closeOnItemClick) {
                   this.closeContext();
               } else {
                   const clickTarget = event.target as HTMLElement;
                   return !!this.overlayRef && !this.overlayRef.overlayElement.contains(clickTarget);
               }
           }), take(1)).subscribe(() => this.closeContext());
 }

 onEditList() {
  const config = new MatDialogConfig();
  config.panelClass = 'dialog';
  config.data = this.validValueItems;

  this.dialog.open(EditEnumDialogComponent, config).afterClosed().subscribe((res) => {
    if (res) {
          this.validValueItems = [];
        
          setTimeout(() => {
            this.updateEnumValue(res);
            this.validValueItems = res;
          }, 100);
      }
  });
}


updateEnumValue(res: EnumValidValueItemModel[]) { 
  if (this.columnPropertyNames.length > 1) {
    const targetValidValueId = res[0]?.ValidValueId;
    const matchingIndexes = this.columnEnums.reduce((acc, col, i) => {
      if (col.length > 0 && col[0].ValidValueId === targetValidValueId) {
        acc.push(i);
      }
      return acc;
    }, [] as number[]);

    // Update matching
    matchingIndexes.forEach(index => {
      const existingEnum = this.columnEnums[index][0].enumValidValue;

      this.columnEnums[index] = res.map(item => ({
        ...item,
        enumValidValue: existingEnum
      }));
    });

     //Apply changes to the canal
     this.dropdownModelsLengthOriginal  = [];
     this.dropdownModelsLengthFiltered = [];
     this.dropdownModels2 = [];
     this.dropdownModels3 = [];
     for (const enu of this.columnEnums[0]) {
       this.dropdownModelsLengthOriginal .push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
         if (!enu.ItemDisplayValue.endsWith('5') && this.isTreatmentEwlAwlFilter) {
         this.dropdownModelsLengthFiltered.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
         }
     }
     this.dropdownModels1 = this.dropdownModelsLengthOriginal ;

    for (const enu of this.columnEnums[1]) {
      this.dropdownModels2.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
    }

    for (const enu of this.columnEnums[2]) {
      this.dropdownModels3.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
    }
   }
  else{
      const existingEnum = this.columnEnums[0]?.[0]?.enumValidValue;
      // Step 2: Apply it to each item in `res`
      this.columnEnums[0] = res.map(item => ({
        ...item,
        enumValidValue: existingEnum // Attach the preserved enumValidValue
      }));

      //Apply changes to the canal
      this.dropdownModelsLengthOriginal  = [];
      for (const enu of this.columnEnums[0]) {
        this.dropdownModelsLengthOriginal .push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
          if (!enu.ItemDisplayValue.endsWith('5') && this.isTreatmentEwlAwlFilter) {
          this.dropdownModelsLengthFiltered.push(new TdoDropdownModel(enu.ItemDisplayValue, enu));
          }
      }
      this.dropdownModels1 = this.dropdownModelsLengthOriginal ;

    }
}

 

 closeContext(): void {
  this.sub !== undefined && this.sub.unsubscribe();
  if (this.overlayRef) {
      this.isContextOpen = false;
      this.overlayRef.dispose();
      this.overlayRef = null;
  }
}
}
